export const REGION = 'eu-west-1';
export const USER_POOL_ID = 'eu-west-1_TjgMxs97M';
export const APP_CLIENT_ID = '5ba2pej472nn874h6fhtve90k';
export const IDENTITY_POOL_ID = 'eu-west-1:359c6555-b5ba-4914-abbf-05da4e5f671d';
export const COGNITO_DOMAIN = 'ee-portal-auth-beta.auth.eu-west-1.amazoncognito.com';
export const IS_LOCAL_DEV = 'false';
export const STAGE = 'beta';
export const APPEAL_ENABLED = 'true';